export const LoaderV4 = () => {
  return (
    <div class="templateV4 wrapper">
      <div class="loader undefined">
        <div class="loader__content">
          <h2 class="loader__title">Loading</h2>
          <div class="circle-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};
